import { Fragment, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { menucontext } from "../../../context/nav/menucontext";
import { getBreadcrumbs } from "../../../helpers/navigation/breadcrumbs";
import { getSiblings } from "../../../helpers/object/depthof";
import Select from "react-select";
import { useEffect } from "react";
import UseBreakpoints from "../../hooks/ui/UseBreakpoints";
const Breadcrumbs = () => {
  const location = useLocation();
  const [selectedMenuKey, setSelectedMenuKey] = useState("");
  const navigate = useNavigate();
  const breakpoints = UseBreakpoints();
  const breadcrumbs = useMemo(
    () => getBreadcrumbs(location.pathname, "url", menucontext),
    [location.pathname]
  );
  const siblings = useMemo(
    () => breadcrumbs ?
      Array.from({ length: breadcrumbs.length }, (x, i) => i).map((x, idx) => {
        return getSiblings(menucontext, x, breadcrumbs);
      }) : null,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [breadcrumbs]
  );
  const options = useMemo(
    () =>
      siblings?.map((x) =>
        x.map(({ key, title }) => {
          return { value: key, label: title };
        })
      ),
    [siblings]
  );
  const currentOption = useMemo(
    () =>
      breadcrumbs?.reverse().map(({ key, title }) => {
        return { value: key, label: title };
      }),
    [breadcrumbs]
  );
  useEffect(() => {
    if (selectedMenuKey) {
      navigate(
        siblings[breadcrumbs.length - 1]?.find((x) => x.key === selectedMenuKey)
          ?.url
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMenuKey]);
  if (!siblings) return null;
  return (
    <Div>
      <div className="inner">
        <Link to="/" className="home" aria-label="홈">
          <svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true">
            <path d="M10 2.5 2 9.2V18h5.5v-5h5v5H18V9.2z" fill="currentColor" />
          </svg>
        </Link>
        {Array.from({ length: breadcrumbs.length }, (x, i) => i).map(
          (x, idx) => {
            return (
              <Fragment key={idx}>
                {x === breadcrumbs.length - 1 ? (
                  <div className="select">
                    <Select
                      options={options[x]}
                      defaultValue={currentOption[x]}
                      isDisabled={x !== breadcrumbs.length - 1}
                      isSearchable={false}
                      onChange={(value) => setSelectedMenuKey(value.value)}
                      styles={selectStyles}
                    />
                  </div>
                ) : (
                  <>{breakpoints.sm && <div className="crumb">{currentOption[x].label}</div>}</>
                )}
              </Fragment>
            );
          }
        )}
      </div>
    </Div>
  );
};

export default Breadcrumbs;
// react-select 기본 테두리를 걷어내고 위치 표시줄에 맞춘다
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "2.5rem",
    border: 0,
    borderRadius: "0.5rem",
    boxShadow: "none",
    backgroundColor: state.menuIsOpen ? "#E7F1FA" : "transparent",
    cursor: "pointer",
    fontWeight: 700,
    color: "#14245C",
  }),
  singleValue: (base) => ({ ...base, color: "#14245C" }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, color: "#0165AC" }),
  menu: (base) => ({
    ...base,
    marginTop: "0.25rem",
    borderRadius: "0.75rem",
    overflow: "hidden",
    boxShadow: "0 12px 32px rgba(20, 36, 92, 0.16)",
    zIndex: 5,
  }),
  option: (base, state) => ({
    ...base,
    cursor: "pointer",
    backgroundColor: state.isSelected ? "#14245C" : state.isFocused ? "#E7F1FA" : "white",
    color: state.isSelected ? "white" : "#151B2C",
  }),
};
const Div = styled.nav`
  width: 100%;
  background-color: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  & > .inner {
    max-width: ${({ theme }) => theme.layout.content};
    margin: 0 auto;
    padding: 0.5rem clamp(1.25rem, 4vw, 2.5rem);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: 0.95rem;
    color: ${({ theme }) => theme.colors.foreground.dimmed};
    & > * {
      display: flex;
      align-items: center;
    }
    & > *:not(:last-child):after {
      content: "›";
      margin: 0 0.75rem;
      color: ${({ theme }) => theme.colors.monotone.medium};
    }
    & > .home {
      color: ${({ theme }) => theme.colors.dark};
      &:hover {
        color: ${({ theme }) => theme.colors.accent};
      }
    }
    & > .select {
      min-width: 12rem;
      & > div {
        flex: 1;
      }
    }
  }
`;
